<template>
    <div class="pagination">
        <div class="pagination__page page-prev" v-show="prevVisible" tabindex="0"
             v-on:click="prevPage"
             v-on:keyup.enter="prevPage">
            <i class="icon-chevron-left"></i>
        </div>
        <div v-for="page in pagesArray" :class="{ 'current' : current == page }" class="pagination__page" tabindex="0"
             v-on:click="setPage(page)" 
             v-on:keyup.enter ="setPage(page)">
            {{ page }}
        </div>
        <div class="pagination__page page-next" v-show="nextVisible" tabindex="0"
            v-on:click="nextPage" 
            v-on:keyup.enter ="nextPage">
            <i class="icon-chevron-right"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props: ['pages','current','submit', 'value'],
        data(){
            return{
                pagesArray:[],
                prevVisible: false,
                nextVisible: false,
            }
        },
        created(){
            this.pagesArray = [];
                for(var i = 1; i <= this.pages;i++){
                    this.pagesArray.push(i);
            }
        },
        watch:{
            current: function(){
                this.prevVisible = this.current != 1 && this.pages > 1;
                this.nextVisible = this.current != this.pages && this.pages > 1;
            },
            pages: function(){
                this.prevVisible = this.current != 1 && this.pages > 1;
                this.nextVisible = this.current != this.pages && this.pages > 1;
                this.pagesArray = [];
                for(var i = 1; i <= this.pages;i++){
                    this.pagesArray.push(i);
                }
            }
        },
        computed: {
            picked: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                    this.submit();
                }
            }
        },
        methods:{
            setPage(page){
                this.picked = page;
            },
            prevPage(){
                this.picked = this.current - 1;
            },
            nextPage(){
                this.picked = this.current + 1;
            },
        }
    }
</script>

<style lang="scss" scoped>

    @import "src/scss/variables";

    .pagination {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        &__page {
            display: inline;
            padding: 0 10px;
            font-family: $main-font;
            cursor: pointer;

            &.current {
                border-width: 2px;
                border-style: solid;
                border-radius: 3px;
                padding: 5px 10px;
            }
        }
       
    }
</style>



// WEBPACK FOOTER //
// src/components/partials/Pagination.vue